import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * The shared helpers live in the engine; the three below need a DOM, so they
 * stay here. Re-exporting the pure ones keeps every `@/lib/utils` import site
 * working and keeps one obvious place to look for a helper.
 */
export { uid, clamp, round, formatBytes, shuffle, safeName } from '@nextcollage/engine';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export function isMac() {
  return typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform);
}
